// Fixed 00:00:00 mask — digits shift in from the right, colons never move
export function maskTime(raw) {
  const d = (raw || '').replace(/\D/g, '').slice(-6).padStart(6, '0');
  return `${d.slice(0, 2)}:${d.slice(2, 4)}:${d.slice(4, 6)}`;
}

// Pin the caret to the end — double-taps can select mid-field digits, and a keystroke
// replacing that selection makes the right-shift mask scramble. Typing must always append.
export function pinCaretEnd(e) {
  const el = e.target;
  const len = el.value.length;
  if (el.selectionStart !== len || el.selectionEnd !== len) el.setSelectionRange(len, len);
}
